module.exports = __webpack_public_path__ + "img/ios.d41a1e9f.png";